export default __webpack_public_path__ + "static/media/pfp-purple.d28f8151.svg";